<template>
  <div>
    <el-select
      :value="value"
      @input="updateValue"
      clearable
      placeholder="活动类型"
      style="width:100%;"
    >
      <el-option
        v-for="(item, key) in list"
        :key="key"
        :label="item.Name"
        :value="item.Value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "activityType",
  props: ["value"],
  created() {
    this.load();
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    load() {
      this.requestApi("activity", "getActivityType", {}, res => {
        this.list = res;
      });
    },
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>
<style lang="less"></style>
